import { render, staticRenderFns } from "./ServiceRecipe.vue?vue&type=template&id=2b5b5b7f&scoped=true&"
import script from "./ServiceRecipe.vue?vue&type=script&lang=js&"
export * from "./ServiceRecipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5b5b7f",
  null
  
)

export default component.exports